import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { InventoryForecastsPage } from "src/components/views/erp/production/reports/inventoryForecast/InventoryForecastsPage.tsx";

export const Route = createFileRoute("/_authenticated/_shell/erp/inventory/forecast")({
	staticData: { title: i18n.t("inventory_forecast"), legacyViewKey: "inventoryForecastsPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <InventoryForecastsPage />;
}
